import Table from '../table/Table';

export type TVisibleXBounds = {
  firstX: number | null;
  lastX: number | null;
};

export function getVisibleXBounds(table: Table | null): TVisibleXBounds {
  const visibleXIndexes = table?.tableBody?.virtualScroller?.visibleXIndexes ?? [];

  return {
    firstX: visibleXIndexes[0] ?? null,
    lastX: visibleXIndexes[visibleXIndexes.length - 1] ?? null,
  };
}
